module.exports = __webpack_public_path__ + "media/images/icons/hammer_v2-e5b709dec70337434f6ee16ecb65704d.svg";